var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.calciatoreInAsta
    ? _c("card-collapsable", {
        attrs: {
          headerClass: "yellow darken-2 white--text",
          dialogClass: "assegna",
          dialogProp: _vm.dialog,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "visible",
              fn: function () {
                return [
                  _c("v-icon", { staticClass: "white--text" }, [
                    _vm._v("add_moderator"),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "title",
              fn: function () {
                return [_vm._v("Assegna calciatore")]
              },
              proxy: true,
            },
            {
              key: "body",
              fn: function () {
                return [
                  _c("calciatore-battuto", {
                    attrs: { id: _vm.calciatoreInAsta, xLarge: "" },
                  }),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    {
                      staticClass: "mt-4",
                      attrs: { justify: "center", "no-gutters": "" },
                    },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "5" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              type: "number",
                              value: _vm.minOfferta,
                              min: _vm.minOfferta,
                              regular: "",
                              "hide-details": "",
                              label: "Costo calciatore",
                              "prepend-icon": "monetization_on",
                            },
                            model: {
                              value: _vm.offerta,
                              callback: function ($$v) {
                                _vm.offerta = $$v
                              },
                              expression: "offerta",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list",
                    { attrs: { dense: "", nav: "" } },
                    [
                      _c("v-subheader", [
                        _vm._v("Seleziona squadra a cui assegnarlo"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "asta-assegna-lista" },
                        _vm._l(_vm.asta_squadre_array, function (sq) {
                          return _c(
                            "v-list-item",
                            {
                              key: sq.id,
                              staticClass: "squadra_list_item",
                              class: _vm.selectedClass(sq.id),
                              attrs: { disabled: _vm.squadraDisabled(sq.id) },
                              on: {
                                click: function ($event) {
                                  return _vm.select(sq.id)
                                },
                              },
                            },
                            [
                              _c("v-list-item-avatar", [
                                _c("img", {
                                  attrs: { src: _vm.squadra(sq.id).pic },
                                }),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", {
                                    staticClass: "squadra_name",
                                    domProps: { textContent: _vm._s(sq.name) },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-list-item-avatar", [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.squadra(sq.id).crediti != null,
                                        expression:
                                          "squadra(sq.id).crediti != null",
                                      },
                                    ],
                                    staticClass: "crediti",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.squadra(sq.id).crediti) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "actions",
              fn: function () {
                return [
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { rounded: "", text: "" },
                          on: {
                            click: function ($event) {
                              return _vm.scarta()
                            },
                          },
                        },
                        [_vm._v("Scarta")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "pa-4 white--text",
                          attrs: {
                            depressed: "",
                            rounded: "",
                            color: "warning",
                            loading: _vm.loading,
                            disabled:
                              _vm.selected == null ||
                              _vm.squadraDisabled(_vm.selected),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.assegna()
                            },
                          },
                        },
                        [_vm._v("Assegna")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pa-2" },
                    [
                      _c(
                        "v-alert",
                        {
                          staticClass: "white--text",
                          attrs: { color: "error" },
                          model: {
                            value: _vm.error,
                            callback: function ($$v) {
                              _vm.error = $$v
                            },
                            expression: "error",
                          },
                        },
                        [
                          _vm._v(
                            "\n        Offerta " +
                              _vm._s(_vm.errorValue) +
                              " non valida. Min: " +
                              _vm._s(_vm.minOfferta) +
                              " - Max:\n        " +
                              _vm._s(_vm.maxOfferta) +
                              "\n      "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          2240929920
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }